import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import {Button, DatePicker, Form, Icon, Input, message, Popconfirm, Popover, Table,Upload} from "antd";
import EditableCell, {EditableContext} from "../../components/Editable/editable-cell";
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";
import "./kt-track-loc-table-mock"
import moment from 'moment';
import 'moment/locale/zh-cn';
import Highlighter from 'react-highlight-words';
const SYS = "mms"
moment.locale('zh-cn');
const PAGE_SIZE = 10;
class KtTrackLocTable extends Component {
    constructor(props, context) {
        super(props, context);
        this.state={
            columns:[],
            dateCols:[],
            tableDataSource:[],
            params:{},
            loading:false,
            pageNum:1,
            total:0,
            editingKey:"",
            editingColKey:"",
            readOnly:true,
            orderId:"",
            searchText: '',
            searchedColumn: '',
            filterDt:"",
            filterCol:null,
        }
        this.table=null
    }
    getTitle=(colName)=> {
        let title = `${colName.slice(5,7)}月${colName.slice(8,10)}日`
        return <Popover content={<span><a style={{marginRight: 8}} onClick={()=>{this.editCol(colName)}}><Icon type="edit" /></a><Popconfirm title="是否确定删除?" onConfirm={() => this.delCol(colName)}><a><Icon type="delete" /></a></Popconfirm></span>}>{title}</Popover>
    }
    createCol=(colName)=>{
        let col = {
            title:this.getTitle(colName),
            dataIndex:colName,
            key:colName,
            colEditable:true,
            editable: true,
            width:100,
            // textWrap: 'word-break',
            // ellipsis: true,
            // render: (text, record) => (
            //     <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
            //         {text}
            //     </div>
            // ),
        }
        return col
    }
    getColumnSearchProps = (dataIndex,title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`搜索 ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    搜索
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    重置
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? 'red' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]?
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()):false,
        onFilterDropdownVisibleChange: visible => {
            //
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text?text.toString():""}
                />
            ) : (
                text
            ),
    });
    handleFilterDt = (selectedKeys, confirm, dataIndex) => {
        confirm();
        let colName = this.state.filterDt
        if(colName) {
            const newDateCols = [this.createCol(colName)];
            this.setState({
                filterCol: newDateCols,
                editingColKey: "",
                newColName: undefined,
            });
        }
    }
    handleFilterDtReset = clearFilters => {
        clearFilters();
        const newDateCols = [...this.state.dateCols];
        let newCols = this.headCols.concat(newDateCols, this.endCols)
        this.setState({
            columns: newCols,
            editingColKey: "",
            filterDt:null,
            filterCol:null,
            newColName: undefined,
        });
    };
    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };
    headCols = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 50,
            render: (text, record, index) => `${index+1+PAGE_SIZE*(this.state.pageNum-1)}`,
        },
        {
            title: '箱号',
            dataIndex: 'boxNo',
            key: 'boxNo',
            fixed: 'left',
            width: 100,
            ...this.getColumnSearchProps("boxNo","箱号"),
        },
        {
            title: '铁路封',
            dataIndex: 'trainNo',
            key: 'trainNo',
            fixed: 'left',
            width: 100,
            ...this.getColumnSearchProps("trainNo","铁路封"),
        },
        {
            title: '运单批号',
            dataIndex: 'trackNo',
            key: 'trackNo',
            fixed: 'left',
            width: 100,
            ...this.getColumnSearchProps("trackNo","运单批号"),
        },
        {
            title: 'GPS编号',
            dataIndex: 'gpsNo',
            key: 'gpsNo',
            fixed: 'left',
            width: 100,
            ...this.getColumnSearchProps("gpsNo","GPS编号"),
        },
    ]
    endCols = [
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            editable: true,
        },
        {
            title: '操作',
            dataIndex: 'opt',
            key: 'opt',
            fixed: 'right',
            width: 100,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <DatePicker
                        ref={node => {
                            this.searchInput = node;
                        }}
                        placeholder={`搜索 `}
                        value={this.state.filterDt?moment(this.state.filterDt, 'YYYY-MM-DD'):null}
                        onChange={
                            (date, dateString)=>{
                                if(date) {
                                    this.setState({filterDt: date.format("YYYY-MM-DD")})
                                }
                            }}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => this.handleFilterDt(selectedKeys, confirm,"1")}
                        icon="search"
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        搜索
                    </Button>
                    <Button onClick={() => this.handleFilterDtReset(clearFilters)} size="small" style={{ width: 90 }}>
                        重置
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{ color: filtered ? 'red' : undefined }} />
            ),
            onFilter: (value, record) =>true,
            onFilterDropdownVisibleChange: visible => {
                //
                if (visible) {
                    //setTimeout(() => this.searchInput.select());
                }
            },
            render: (text,record) => {
                return this.isEditing(record) ?(
                    <span>
                          <EditableContext.Consumer>
                            {form => (
                                <a
                                    onClick={() => this.save(form, record.id)}
                                    style={{marginRight: 8}}
                                >
                                    保存
                                </a>
                            )}
                          </EditableContext.Consumer>
                          <a  onClick={() => this.cancel()}>取消</a>
                        </span>
                ):(
                    <span>
                    {this.state.readOnly?null:(<a disabled={this.state.editingKey !== '' || this.state.editingColKey!==''} onClick={() => this.edit(record.id)} style={{marginRight: 8}}>修改</a>)}
                        <a onClick={()=>{
                            this.scrollInto(record.gpsNo)
                        }}>定位</a>
                </span>
                )},
        },
    ]

    scrollInto=(id)=>{
        if(!id){
            message.info("没有绑定GPS设备!")
            return
        }
        let anchorElement = document.getElementById(id);
        if(anchorElement) {
            anchorElement.scrollIntoView({block: "start", inline: "start"});
            if(this.props.tabChange){
                this.props.tabChange(id)
            }
        }else{
            console.log(id+" not found")
        }
    }
    isEditing = record => record.id === this.state.editingKey;
    edit=(key)=> {
        this.setState({ editingKey: key });
    }
    doSearch=(params=null)=>{
        if(params){
            this.setState({
                params:params
            })
            if(params.pageNum){
                this.setState({
                    pageNum:params.pageNum,
                })
            }
        }
        this.getDataSource(params);
    }
    getDataSource=(params=null)=> {
        this.setState({
            loading:true,
        })
        if(!params) {
            params={orderId:this.state.orderId}
        }
        let result = ajax(baseUrl+"/api/v1/p/"+SYS+"/delivery/notes/group",params);
        result.then((resp)=>{
            if(resp.code === 200){
                this.handleCols(resp.data)
                this.setState({
                    total: resp.data.total,
                    tableDataSource:resp.data
                })
            }else{
                message.error(resp.message)
                this.setState({
                    total: 0,
                    tableDataSource:[]
                })
            }
        }).catch(()=>{
            this.setState({
                total: 0,
                tableDataSource:[]
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    reset=(dataIndex)=>{
        const newDateCols = [...this.state.dateCols];
        const index = newDateCols.findIndex(item => dataIndex === item.dataIndex);
        if (index > -1) {
            const item = newDateCols[index];
            let newItem = Object.assign({},item)
            let title = `${dataIndex.slice(5,7)}月${dataIndex.slice(8,10)}日`
            newItem.title= this.getTitle(dataIndex)
            newItem.dataIndex = dataIndex
            newDateCols.splice(index, 1, {
                ...item,
                ...newItem,
            });
            let newCols = this.headCols.concat(newDateCols,this.endCols)
            // const newData = [...this.state.tableDataSource];
            // newData.forEach((value,index)=>{
            //     if(value.hasOwnProperty(dateIndex)){
            //         value[colName]=value[dateIndex]
            //         delete value[dateIndex]
            //     }
            // })
            //this.changeCol(this.state.orderId,dateIndex,colName)
            this.setState({
                //tableDataSource:newData,
                dateCols:newDateCols,
                columns: newCols,
                editingColKey:"",
                newColName:undefined,
            });
        }
    }
    editCol=(dataIndex)=>{
        let oldDataIndex = this.state.editingColKey
        this.setState({editingColKey:dataIndex,newColName:undefined})
        const newDateCols = [...this.state.dateCols];
        const index = newDateCols.findIndex(item => dataIndex === item.dataIndex);
        const index2 = newDateCols.findIndex(item => oldDataIndex === item.dataIndex);
        if (index > -1) {
            const item = newDateCols[index];
            let newItem = Object.assign({},item)
            let title = <DatePicker format={"YYYY年MM月DD日"} defaultValue={false?moment(this.state.newColName, 'YYYY-MM-DD'):moment(dataIndex, 'YYYY-MM-DD')} onChange={
                (date, dateString)=>{
                    if(date) {
                        this.setState({newColName: date.format("YYYY-MM-DD")})
                    }
                }
            }/>
            newItem.title= title
            //newItem.dataIndex = colName
            newDateCols.splice(index, 1, {
                ...item,
                ...newItem,
            });
            if(index2>-1){
                const item = newDateCols[index2];
                let newItem = Object.assign({},item)
                let title = `${oldDataIndex.slice(5,7)}月${oldDataIndex.slice(8,10)}日`
                newItem.title= <Popover content={<a onClick={()=>{this.editCol(oldDataIndex)}}>修改</a>}>{title}</Popover>
                //newItem.dataIndex = colName
                newDateCols.splice(index2, 1, {
                    ...item,
                    ...newItem,
                });
            }
            let newCols = this.headCols.concat(newDateCols,this.endCols)
            // const newData = [...this.state.tableDataSource];
            // newData.forEach((value,index)=>{
            //     if(value.hasOwnProperty(dateIndex)){
            //         value[colName]=value[dateIndex]
            //         delete value[dateIndex]
            //     }
            // })
            //this.changeCol(this.state.orderId,dateIndex,colName)
            this.setState({
                //tableDataSource:newData,
                dateCols:newDateCols,
                columns: newCols,
                //editingColKey:"",
                //newColName:undefined,
            });
        }
    }

    handleCols=(data)=>{
        let dateCols = []
        let regExp = /\d{4}-\d{2}-\d{2}/
        let colNames = new Set()
        data.forEach((item)=>{
            let keys = Object.keys(item)
            keys.forEach((key)=>{
                if(regExp.test(key)){
                    colNames.add(key)
                }
            })
        })
        if(colNames ){
            let sortCol = Array.from(colNames)
            this.setState({scrollX:colNames.size*100+650},()=>{
                console.log(this.state.scrollX)
            })
            sortCol.sort((a,b)=>{
                let m1 = moment(a, 'YYYY-MM-DD')
                let m2 = moment(b, 'YYYY-MM-DD')
                return m1.isBefore(m2)?1:-1
            })
            sortCol.forEach((colName)=>{
                dateCols.push(this.createCol(colName))
            })
            this.setState({
                dateCols
            })
            let newCols = this.headCols.concat(dateCols,this.endCols)
            this.setState({
                columns: newCols,
            });
        }

    }
    cancel = () => {
        this.setState({ editingKey: '' });
    }
    getLocationReq=(item)=>{
        let regExp = /\d{4}-\d{2}-\d{2}/
        let colNames = new Set()
        let keys = Object.keys(item)
        let req = {...item}
        let locs = []
        keys.forEach((key)=>{
            if(regExp.test(key)){
                let loc = {
                    dateStr:key,
                    location:item[key],
                }
                locs.push(loc)
            }
        })
        req["locationItems"]=locs
        return req
    }
    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.tableDataSource];
            const index = newData.findIndex(item => key === item.id);
            if (index > -1) {
                const item = newData[index];
                let newItem = Object.assign(item,row)
                newData.splice(index, 1, {
                    ...item,
                    ...newItem,
                });
                this.saveLoc(this.getLocationReq(newItem))
                //this.doupd({id:item.id,entId:item.entId})
                this.setState({ tableDataSource: newData, editingKey: '' });
            } else {
                //newData.push(row);
                this.setState({ tableDataSource: newData, editingKey: '' });
            }
        });
    }
    saveLoc=(loc)=>{
        let result = ajax(baseUrl+'/api/v1/p/'+SYS+'/delivery/notes',loc,"POST");
        result.then((resp)=> {
            if (resp.code === 200) {
                message.info("更新成功")
            }else if(resp.code === 201){
                message.info("保存成功")
            }else{
                message.error(resp.message)
                this.setState({
                })
            }
        }).catch(()=>{
            this.setState({
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    addCol=(colName)=>{
        for(let col of this.state.columns){
            if(col.dataIndex === colName){
                message.error(`${colName.slice(0,4)}年${colName.slice(5,7)}月${colName.slice(8,10)}日已存在!`)
                return
            }
        }
        let col = this.createCol(colName)
        let newDateCols = [...this.state.dateCols]
        newDateCols.splice(0, 0, col);
        let newCols = this.headCols.concat(newDateCols,this.endCols)
        this.setState({
            dateCols:newDateCols,
            columns: newCols,
            newColName:undefined,
        });

        let tableDOM=ReactDOM.findDOMNode(this.table)
        let scrollDom = tableDOM.getElementsByClassName("ant-table-body")[0]
        scrollDom.scrollTo(0,0)
    }
    delCol=(dataIndex)=>{
        let newDateCols = [...this.state.dateCols]
        const index = newDateCols.findIndex(item => dataIndex === item.dataIndex);
        if(index>-1){
            newDateCols.splice(index, 1);
            this.reqDelCol(this.state.orderId,dataIndex)
            let newCols = this.headCols.concat(newDateCols,this.endCols)
            this.setState({
                dateCols:newDateCols,
                columns: newCols,
                newColName:undefined,
            });
        }
    }
    reqDelCol=(orderId,dateStr)=>{
        let params={
            orderId:orderId,
            dateStr:dateStr
        }
        const formData = new FormData();
        formData.append("orderId",orderId)
        formData.append("dateStr",dateStr)
        let result = ajax(baseUrl+'/api/v1/p/'+SYS+'/delivery/notes/dt/del',formData,"POST");
        result.then((resp)=> {
            if (resp.code === 200) {
                message.info("删除成功")
            }else{
                message.error(resp.message)
                this.setState({
                })
            }
        }).catch(()=>{
            this.setState({
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    changeCol=(orderId,dateStr,newDateStr)=>{
        let params={
            orderId:orderId,
            dateStr:dateStr,
            newDateStr:newDateStr,
        }
        const formData = new FormData();
        formData.append("orderId",orderId)
        formData.append("dateStr",dateStr)
        formData.append("newDateStr",newDateStr)
        let result = ajax(baseUrl+'/api/v1/p/'+SYS+'/delivery/notes/dt/update',formData,"POST");
        result.then((resp)=> {
            if (resp.code === 200) {
                message.info("更新成功")
            }else if(resp.code === 201){
                message.info("保存成功")
            }else{
                message.error(resp.message)
                this.setState({
                })
            }
        }).catch(()=>{
            this.setState({
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    saveCol=(dateIndex,colName)=>{
        for(let col of this.state.columns){
            if(col.dataIndex === colName){
                message.error(`${colName.slice(0,4)}年${colName.slice(5,7)}月${colName.slice(8,10)}日已存在!`)
                // this.setState({
                //     editingColKey:"",
                //     newColName:undefined,
                // },()=>{
                //     this.reset(dateIndex)
                // })
                return
            }
        }
        const newDateCols = [...this.state.dateCols];
        const index = newDateCols.findIndex(item => dateIndex === item.dataIndex);
        if (index > -1) {
            const item = newDateCols[index];
            let newItem = Object.assign({},item)
            let title = `${colName.slice(5,7)}月${colName.slice(8,10)}日`
            newItem.title= this.getTitle(colName)
            newItem.dataIndex = colName
            newDateCols.splice(index, 1, {
                ...item,
                ...newItem,
            });
            let newCols = this.headCols.concat(newDateCols,this.endCols)
            const newData = [...this.state.tableDataSource];
            newData.forEach((value,index)=>{
                if(value.hasOwnProperty(dateIndex)){
                    value[colName]=value[dateIndex]
                    delete value[dateIndex]
                }
            })
            this.changeCol(this.state.orderId,dateIndex,colName)
            this.setState({
                tableDataSource:newData,
                dateCols:newDateCols,
                columns: newCols,
                editingColKey:"",
                newColName:undefined,
            });
        }
    }
    componentDidMount() {
    }
    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.orderId!==this.state.orderId) {
            this.setState({
                orderId:nextProps.orderId,
            },()=>{
                this.doSearch({orderId:nextProps.orderId})
            })
        }
        if(nextProps.readOnly!==this.state.readOnly) {
            this.setState({
                readOnly:nextProps.readOnly,
            })
        }
    }

    render() {
        const columns = this.state.filterCol?[...this.headCols, ...this.state.filterCol, ...this.endCols]:[...this.headCols, ...this.state.dateCols, ...this.endCols]
        const props = {
            name: 'file',
            showUploadList:false,
            action: baseUrl+'/api/v1/p/'+SYS+'/delivery/notes/import?orderId='+this.state.orderId,
            headers: {
                authorization: 'authorization-text',
            },
            onChange:(info) =>{
                if (info.file.status !== 'uploading') {
                    //console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    if(info.file.response.code === 200){
                        message.success(`${info.file.name} 导入成功`);
                    }else{
                        message.error(`${info.file.name} 导入失败`);
                        window.location.href = baseUrl.replace('/'+SYS, '/upload/') + info.file.response.data.errUrl;
                    }
                    this.doSearch({orderId:this.state.orderId})

                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} 上传失败，请重试.`);
                }
            },
        };
        const EditableHeader = props => {
            const { dataIndex,children,colEditable, ...restProps } = props;
            return (<th {...restProps} >
                {this.state.editingColKey===dataIndex?
                    (<DatePicker format={"YYYY年MM月DD日"} value={this.state.newColName?moment(this.state.newColName, 'YYYY-MM-DD'):moment(dataIndex, 'YYYY-MM-DD')} onChange={
                        (date, dateString)=>{
                            if(date) {
                                this.setState({newColName: date.format("YYYY-MM-DD")})
                            }
                        }
                    }/>)
                    :(colEditable?((<Popover content={<a onClick={()=>{this.setState({editingColKey:dataIndex,newColName:undefined})}}>修改</a>}>{children}</Popover>)):(children))}
            </th>);
        }
        const components = this.state.readOnly ||this.state.editingKey?{
            body: {
                cell: EditableCell,
            }
        }:{
            // header: {
            //     cell: EditableHeader,
            // },
            body: {
                cell: EditableCell,
            },
        };
        const editCols = columns.map(col => {
            if (!col.editable) {
                return {
                    ...col,
                    onHeaderCell: column => ({
                        dataIndex: col.dataIndex,
                        colEditable:col.colEditable,
                    }),
                };
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'id' ? 'number' : 'text',
                    options:col.options,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    required:col.required,
                    editing: this.isEditing(record),
                }),
                onHeaderCell: column => ({
                    dataIndex: col.dataIndex,
                    colEditable:col.colEditable,
                }),
            };
        });
        return (
            <EditableContext.Provider value={this.props.form}>
                <Table
                    bordered
                    size="middle"
                    ref={(view)=>{this.table=view}}
                    scroll={{ x: this.state.scrollX }}
                    components={components}
                    title={this.state.readOnly?null:()=>(
                        <div style={{textAlign:"right"}}>{this.state.editingColKey?(
                            <span>
                                <Button type="primary" onClick={() => {this.saveCol(this.state.editingColKey,this.state.newColName)}} style={{marginRight: 8}} disabled={this.state.newColName===undefined}>保存</Button>
                                <Button onClick={()=>{this.reset(this.state.editingColKey)}}>取消</Button>
                            </span>
                        ):(
                            <span>
                                    <Button style={{marginRight: 8}}
                                            onClick={()=>{
                                                window.location.href = baseUrl.replace('/'+SYS, '/upload') + '/template/订单备注模板.xlsx';
                                            }}
                                    >模板下载</Button>
                                    <Upload {...props}>
                                    <Button style={{marginRight: 8}}>批量导入</Button>
                                    </Upload>
                                    <Popconfirm placement="topRight"
                                                title={<div><p>请选择日期</p><p><DatePicker value={this.state.newColName===undefined?null:moment(this.state.newColName, 'YYYY-MM-DD')} format={"YYYY年MM月DD日"} onChange={(date, dateString)=>{this.setState({newColName:date.format("YYYY-MM-DD")})}}/></p></div>}
                                                okText="添加"
                                                cancelText="取消"
                                                disabled={this.state.editingKey !== ''}
                                                onCancel={(() => {this.setState({newColName:undefined})})}
                                                onConfirm={()=>{
                                                    if(this.state.newColName!==undefined){this.addCol(this.state.newColName)}
                                                }}>
                                        <Button type="primary" disabled={this.state.editingKey !== ''}>添加列</Button>
                                    </Popconfirm>
                                </span>
                        )}
                        </div>
                    )
                    }
                    columns={editCols}
                    rowKey="id"
                    dataSource={this.state.tableDataSource}
                    loading={this.state.loading}
                    pagination={{

                        pageSize:PAGE_SIZE,
                        showQuickJumper: true,
                        onChange:(page, pageSize)=>{
                            this.setState({
                                pageNum:page
                            })
                        }
                    }}
                />
            </EditableContext.Provider>
        )
    }
}
const KtTrackLocTableForm = Form.create()(KtTrackLocTable)
export default KtTrackLocTableForm